// editorActions.js

export const ADD_PAGE = "ADD_PAGE";
export const EDIT_PAGE = "EDIT_PAGE";
export const DELETE_PAGE = "DELETE_PAGE";
export const EDIT_DOCUMENT_NAME = "EDIT_DOCUMENT_NAME";
export const ADD_DOCUMENT = "ADD_DOCUMENT";
export const UPDATE_DOCUMENT = "UPDATE_DOCUMENT";
export const FIND_DOCUMENT_BY_ID = "FIND_DOCUMENT_BY_ID";
export const DELETE_DOCUMENT = "DELETE_DOCUMENT";
export const EDIT_DOCUMENT_ID = "EDIT_DOCUMENT_ID";
export const SAVED_CHANGE = "SAVED_CHANGE";

// Action pour ajouter une page
export const addPage = (page) => ({
  type: ADD_PAGE,
  payload: page,
});

// Action pour supprimer une page
export const deletePage = (pageId) => ({
  type: DELETE_PAGE,
  payload: pageId,
});

// editorActions.js
export const selectCurrentContent = (state) => {
  const document = state.documents.find(d => d.id === state.selectedDocumentId);
  if (!document) return '';
  const page = document.pages[state.currentPageIndex];
  return page?.text || '';
};
